import { StyleSheet } from 'aphrodite';
import { darkGrayFontColor } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	multiLineAddress: {
		color: darkGrayFontColor,
		fontSize: 14,
	},
});
